import {
  formatLongDate as commonFormatLongDate,
  formatLongMonth as commonFormatLongMonth,
  formatLongMonthDay as commonFormatLongMonthDay,
  formatLongWeekday as commonFormatLongWeekday,
  formatRelative as commonFormatRelative,
  formatShortDate as commonFormatShortDate,
  formatShortMonth as commonFormatShortMonth,
  formatShortMonthDay as commonFormatShortMonthDay,
  formatShortWeekday as commonFormatShortWeekday,
  formatTime as commonFormatTime,
} from '@rewardopl/utils/date';

import { locale } from '../i18n/i18n';

import type { Locale } from '@rewardopl/types';

type Options = {
  locale?: Locale;
};

function getOptionsWithLocale(options: Options): Options {
  const optionsWithLocale = {
    ...options,
  };

  if (locale) {
    optionsWithLocale.locale = locale;
  }

  return optionsWithLocale;
}

export function withLocale<T, U>(
  fn: (value?: T, options?: Options) => U,
): (value?: T, options?: Options) => U {
  return function withLocaleInternal(value?: T, options = {}) {
    const optionsWithLocale = getOptionsWithLocale(options);

    return fn(value, optionsWithLocale);
  };
}

export const formatTime = withLocale(commonFormatTime);
export const formatLongDate = withLocale(commonFormatLongDate);
export const formatShortDate = withLocale(commonFormatShortDate);
export const formatLongMonth = withLocale(commonFormatLongMonth);
export const formatLongMonthDay = withLocale(commonFormatLongMonthDay);
export const formatShortMonth = withLocale(commonFormatShortMonth);

export const formatShortMonthDay = withLocale(commonFormatShortMonthDay);
export const formatLongWeekday = withLocale(commonFormatLongWeekday);
export const formatShortWeekday = withLocale(commonFormatShortWeekday);

export const formatRelative = withLocale(commonFormatRelative);
